export default "__VITE_ASSET__B1__d304__";